import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button/Button'
import Select from '../Select/Select'
import SelectMultiple from '../SelectMultiple/SelectMultiple'
import TextField from '../TextField/TextField';
import CheckboxNew from '../CheckboxNew/CheckboxNew'
import Svg from "../../assets/icons/icons"
import { register, login, getRegisterInfo, resetPassword, clearMessages } from '../../store/auth/actions';
import i18n from "i18next";
import { validateEmail, validatePass, emptyField } from "../../services/utils";
import { add } from './add';
import { adaptData, adaptTypeRightData, sortingData } from "../../services/login";
import { H4, Medium } from "../../styles/typography/typography"
import { colors as c } from "../../styles/variables"
import {
    InputWrapStyled,
    InputIconWrapStyled,
    TabContainerStyled,
    ContentStyled,
    FormStyled,
    ListStyled,
    ItemStyled,
    LinkStyle,
    InfoFormStyled,
    RememberBlockStyled,
    TextBlockStyled,
    PopupLoginStyled,
    RowStyled,
    ButtonWrapStyled,
    ErrorStyled,
    ErrorBlockStyled,
} from "./style";


const emptyFormErrors = {
    password: "",
    email: "",
    fullName: "",
    newEmail: "",
    confirmPassword: "",
    country: "",
    newPassword: "",
    company: "",
    position: "",
    genresChosen: "",
    rightChosen: "",
    territoryChosen: "",
};

const initialState = {

    removeAllСhoice: false,
    tabIndex: 0,
    isShowPass: false,
    isShowNewPass: false,
    isShowConfirmPass: false,
    isShowRestorePass: false,
    isShowSuccessRePas: false,
    rememberMe: false,
    email: "",
    password: "",
    formErrors: { ...emptyFormErrors },
    // для работы селектов
    closeAllSelect: false, // контроль закрытия всех селектов

    emailValid: false,
    passwordValid: false,
    formLoginValid: false,

    formRestPasValid: false,


    territoryValid: false,
    rightValid: false,
    genresValid: false,
    formRegValid: false,

    fullName: "",
    newEmail: "",
    country: "",
    company: "",
    position: "",
    genres: "",
    newPassword: "",
    confirmPassword: "",
    loading: false
};

// пересчёт общего флага валидности формы регистрации
const withRegFormValid = (state) => ({
    ...state,
    formRegValid:
        state.fullnamelValid &&
        state.newEmailValid &&
        state.newPasswordValid &&
        state.confirmPasswordValid &&
        state.companyValid &&
        state.positionValid &&
        state.genresValid &&
        state.rightValid &&
        state.territoryValid
});

// валидация поля формы регистрации, возвращает новое состояние
const applyRegFieldValidation = (state, fieldName, value) => {
    const fieldValidationErrors = { ...state.formErrors };

    let fullnamelValid = state.fullnamelValid;
    let newPasswordValid = state.newPasswordValid;
    let confirmPasswordValid = state.confirmPasswordValid;
    let companyValid = state.companyValid;
    let positionValid = state.positionValid;

    switch (fieldName) {
        case 'fullName':
            fullnamelValid = value.length >= 4;
            fieldValidationErrors.fullName = (value.length < 4 && value.length !== 0) ? i18n.t(`login.fullname_length_less_than_4_characters`) : (value.length === 0) ? i18n.t(`login.fill_in_the_field`) : "";
            break;
        case 'newEmail':
            fieldValidationErrors.newEmail = (value === "") ? i18n.t(`login.fill_in_the_field`) : validateEmail(value) ? "" : i18n.t(`login.invalid_email_format`);
            break;
        case 'newPassword':
            newPasswordValid = validatePass(value);
            fieldValidationErrors.newPassword = (value === "") ? i18n.t(`login.fill_in_the_field`) : newPasswordValid ? "" : i18n.t(`login.password_length_less_than_8_characters`);
            break;
        case 'company':
            companyValid = value.length > 0;
            fieldValidationErrors.company = emptyField(value)
            break;
        case 'position':
            positionValid = value.length > 0;
            fieldValidationErrors.position = emptyField(value)
            break;
        case 'confirmPassword':
            if (state.newPassword !== "" && state.newPassword === state.confirmPassword) {
                if (!validatePass(value)) {
                    confirmPasswordValid = false
                    fieldValidationErrors.newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
                }
            }
            else {
                fieldValidationErrors.confirmPassword = i18n.t(`login.passwords_do_not_match`) //Пароли не совпадают
                confirmPasswordValid = false
            }
            if (state.newPassword === state.confirmPassword) {
                fieldValidationErrors.confirmPassword = ""
                confirmPasswordValid = true
            }
            break;
        default:
            break;
    }

    return withRegFormValid({
        ...state,
        formErrors: fieldValidationErrors,
        newEmailValid: validateEmail(state.newEmail),
        fullnamelValid,
        newPasswordValid,
        confirmPasswordValid,
        companyValid,
        positionValid,
    });
};

// валидация поля формы входа, возвращает новое состояние
const applyLoginFieldValidation = (state, fieldName, value) => {
    const fieldValidationErrors = { ...state.formErrors };
    let emailValid = state.emailValid;
    let passwordValid = state.passwordValid;

    switch (fieldName) {
        case 'email':
            emailValid = validateEmail(value)
            fieldValidationErrors.email = (value === "") ? i18n.t(`login.fill_in_the_field`) : emailValid ? "" : i18n.t(`login.invalid_email_format`);
            break;
        case 'password':
            passwordValid = value.length >= 1;
            fieldValidationErrors.password = passwordValid ? "" : i18n.t(`login.fill_in_the_field`);
            break;
        default:
            break;
    }

    return {
        ...state,
        formErrors: fieldValidationErrors,
        emailValid,
        passwordValid,
        formLoginValid: emailValid && passwordValid,
    };
};

// валидация поля формы сброса пароля, возвращает новое состояние
const applyPassResetFieldValidation = (state, fieldName, value) => {
    const fieldValidationErrors = { ...state.formErrors };
    let emailValid = state.emailValid;

    switch (fieldName) {
        case 'email':
            emailValid = validateEmail(value)
            fieldValidationErrors.email = (!value) ? i18n.t(`login.fill_in_the_field`) : emailValid ? "" : i18n.t(`login.invalid_email_format`);
            break;
        default:
            break;
    }

    return {
        ...state,
        formErrors: fieldValidationErrors,
        emailValid,
        formRestPasValid: emailValid,
    };
};


const LogIn = ({ viewType }) => {
    const [state, setState] = useState(initialState);

    const dispatch = useDispatch();

    const message = useSelector((store) => store.auth.message);
    const errors = useSelector((store) => store.auth.errors);
    const successRequest = useSelector((store) => store.auth.successRequest);
    const register_info = useSelector((store) => store.auth.register_info);
    const loadingRegisterInfo = useSelector((store) => store.auth.loading_register_info);

    const updateState = useCallback((patch) => {
        setState((prev) => ({ ...prev, ...(typeof patch === "function" ? patch(prev) : patch) }));
    }, []);

    // componentDidMount
    useEffect(() => {
        dispatch(clearMessages());
        dispatch(getRegisterInfo());
    }, [dispatch]);

    // componentDidUpdate: реакция на успешный запрос сброса пароля
    useEffect(() => {
        if (successRequest) {
            updateState({ isShowRestorePass: false, isShowSuccessRePas: true });
        }
    }, [successRequest, updateState]);

    // отслеживания изменений в форме регистрации
    const handleFieldChange = (e) => {
        const isCheckbox = e.target.type === "checkbox";
        const name = e.target.name;
        const value = e.target.value;

        setState((prev) => applyRegFieldValidation(
            { ...prev, [name]: isCheckbox ? e.target.checked : value },
            name,
            value
        ));
    };

    // отслеживания изменений в форме входа
    const handleFieldLoginChange = (e) => {
        const isCheckbox = e.target.type === "checkbox";
        const name = e.target.name;
        const value = e.target.value;

        setState((prev) => applyLoginFieldValidation(
            { ...prev, [name]: isCheckbox ? e.target.checked : value },
            name,
            value
        ));
    };

    // отслеживания изменений в форме сброса пароля
    const handleFieldPassResetChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setState((prev) => applyPassResetFieldValidation(
            { ...prev, [name]: value },
            name,
            value
        ));
    };

    // при открытии второго селектора закрываем первый
    const _closeAllSelect = useCallback(() => {
        updateState({ closeAllSelect: true });
        setTimeout(() => {
            updateState({ closeAllSelect: false });
        }, 50);
    }, [updateState]);

    const updateSelectData = useCallback((data, selectName) => {
        const value = sortingData(data);

        setState((prev) => {
            const fieldValidationErrors = { ...prev.formErrors };
            let genresValid = prev.genresValid;
            let territoryValid = prev.territoryValid;
            let rightValid = prev.rightValid;

            switch (selectName) {
                case 'genres':
                    genresValid = value.length >= 1;
                    fieldValidationErrors.genresChosen = genresValid ? "" : i18n.t(`login.select_genres_of_interest`);
                    break;
                case 'territory':
                    territoryValid = value.length >= 1;
                    fieldValidationErrors.territoryChosen = territoryValid ? "" : i18n.t(`login.select_the_territory_of_the_rights_of_interest`);
                    break;
                case 'right':
                    rightValid = value.length >= 1;
                    fieldValidationErrors.rightChosen = rightValid ? "" : i18n.t(`login.select_type_of_rights`);
                    break;
                default:
                    break;
            }

            return withRegFormValid({
                ...prev,
                [selectName]: value,
                formErrors: fieldValidationErrors,
                genresValid,
                rightValid,
                territoryValid,
            });
        });

        _closeAllSelect();
    }, [_closeAllSelect]);

    // кнопка "Забыли пароль"/ Вернуться к входу - переход между вкладками восстановления пароля
    const toResetPassword = (e) => {
        e.preventDefault();
        updateState((prev) => ({
            isShowRestorePass: !prev.isShowRestorePass,
            formErrors: { ...emptyFormErrors },
        }));
        dispatch(clearMessages());
    };

    // переключения по вкладкам вход/ регистрация
    const handleToggleTabs = (index) => {
        updateState({
            tabIndex: index,
            formErrors: { ...emptyFormErrors },
        });
        dispatch(clearMessages());
    };

    // валидация всех полей формы входа
    const validateLogIn = () => {
        const isValidateEmail = validateEmail(state.email);

        const email = (!state.email)
            ? i18n.t(`login.fill_in_the_field`) //Заполните поле
            : (state.email && !isValidateEmail)
                ? i18n.t(`login.invalid_email_format`) //Неверный формат e-mail
                : ""

        const password = (!state.password) ? i18n.t(`login.fill_in_the_field`) : "" //Заполните поле

        if (email || password) {
            updateState({ formErrors: { email, password } });
            return false
        }
        return true
    };

    const handleLogInSubmit = (e) => {
        e.preventDefault();
        const isValid = validateLogIn();
        add()
        if (isValid) {
            updateState({ formErrors: { email: "", password: "" } });
            dispatch(login({
                email: state.email,
                password: state.password
            }));
        }
        else {
            updateState({ loading: false });
        }
    };

    // удалить после реализации кнопки disabled
    const validateResetPass = () => {
        const isValidateEmail = validateEmail(state.email);

        const email = (!state.email)
            ? i18n.t(`login.fill_in_the_field`) //Заполните поле
            : (state.email && !isValidateEmail)
                ? i18n.t(`login.invalid_email_format`) //Неверный формат e-mail
                : ""

        if (email) {
            updateState({ formErrors: { email } });
            return false
        }

        return true
    };

    const handleRestorePassSubmit = (e) => {
        e.preventDefault();
        if (validateResetPass()) {
            updateState({ formErrors: { email: "" } });
            dispatch(resetPassword({ email: state.email }));
        }
    };

    const validateReg = () => {
        const isValidateEmail = validateEmail(state.newEmail);
        const isValidatePass = validatePass(state.newPassword);

        const genres = document.querySelector('input[name="genres"]').value;
        const right = document.querySelector('input[name="right"]').value;
        const territory = document.querySelector('input[name="territory"]').value;

        let fullName = "";
        let confirmPassword = "";

        fullName = (!state.fullName) ? i18n.t(`login.fill_in_the_field`) : "";  //Заполните поле
        const newEmail = (!state.newEmail)
            ? i18n.t(`login.fill_in_the_field`) //Заполните поле
            : (state.newEmail && !isValidateEmail)
                ? i18n.t(`login.invalid_email_format`) //Неверный формат e-mail
                : ""

        const company = (!state.company) ? i18n.t(`login.fill_in_the_field`) : "";  //Заполните поле
        const position = (!state.position) ? i18n.t(`login.fill_in_the_field`) : "";  //Заполните поле

        fullName = (!state.position) ? i18n.t(`login.fill_in_the_field`) : "";  //Заполните поле
        const country = (!state.country) ? i18n.t(`login.choose_the_country`) : "";  //Заполните поле

        let newPassword = (!state.newPassword)
            ? i18n.t(`login.fill_in_the_field`)
            : (state.newPassword && !isValidatePass)
                ? i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
                : "";

        if (state.newPassword && !isValidatePass) {
            newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
        }

        if (state.newPassword && state.newPassword === state.confirmPassword) {
            if (!isValidatePass) {
                newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
            }
        }
        else {
            confirmPassword = i18n.t(`login.passwords_do_not_match`) //Пароли не совпадают
        }

        const rightChosen = (right.length === 0) ? i18n.t(`login.select_type_of_rights`) : ""; //Выберите вид прав
        const genresChosen = (genres.length === 0) ? i18n.t(`login.select_genres_of_interest`) : ""; //Выберите интересующие жанры
        const territoryChosen = (territory.length === 0) ? i18n.t(`login.select_the_territory_of_the_rights_of_interest`) : ""; //Выберите территорию интересующих прав

        if (fullName || company || country || newEmail || position || newPassword || confirmPassword || genresChosen) {
            updateState({
                formErrors: {
                    fullName,
                    newEmail,
                    newPassword,
                    company,
                    country,
                    position,
                    confirmPassword,
                    genresChosen,
                    rightChosen,
                    territoryChosen,
                }
            });
            return false
        }

        return true
    };

    // вкладка регистрация отправка данных
    const handleRegSubmit = (e) => {
        e.preventDefault();
        const isValidateReg = validateReg();

        const genres = document.querySelector('input[name="genres"]').value.split(',');
        const right = document.querySelector('input[name="right"]').value.split(',');
        const territory = document.querySelector('input[name="territory"]').value.split(',');

        if (isValidateReg) {
            updateState({ formErrors: { ...emptyFormErrors } });
            dispatch(register({
                full_name: state.fullName,
                position: state.position,
                email: state.newEmail,
                country_id: state.country,
                company_name: state.company,
                password: state.newPassword,
                password_confirmation: state.confirmPassword,
                rights: right,
                countries: territory,
                genres: genres,
            }));
        }
    };

    const showSearchingResults = (x) => {
        updateState({ country: x });
    };

    //Вид прав
    const typeRightsArr = register_info.rights;
    const typeRightsArrAdapt = typeRightsArr.map((typeRight) => adaptTypeRightData(typeRight));
    const typeRightsList = [i18n.t(`login.type_of_rights`), typeRightsArrAdapt]
    // Территория интересующих прав
    const countriesArr = register_info.countries;
    const countriesArrAdapt = countriesArr.map((country) => adaptData(country));
    const territoryRightsList = [i18n.t(`login.territory_of_the_rights_of_interest`), countriesArrAdapt]
    // Интересующие жанры
    const genresArr = register_info.genres;
    const genresArrAdapt = genresArr.map((genre) => adaptData(genre));
    const genresList = [i18n.t(`login.select_genres_of_interest*`), genresArrAdapt]
    const tabsItems = [
        { title: i18n.t(`login.login`) },
        { title: i18n.t(`login.registration`) },
    ];
    const countryList = [i18n.t(`login.country`), countriesArrAdapt];
    const serverErrors = Object.values(errors);


    /* вкладка восстановление пароля */
    const contentForTabRecoveryPass =
        <FormStyled
            onSubmit={(e) => handleRestorePassSubmit(e)}
            action="#" method="post"
        >
            <InfoFormStyled> {i18n.t(`login.inform.${0}.text1`)} <br /> {i18n.t(`login.inform.${0}.text2`)}
                <br /> {i18n.t(`login.inform.${0}.text3`)}
            </InfoFormStyled>
            <RowStyled>
                <InputWrapStyled>
                    <TextField
                        handleFieldChange={(e) => handleFieldPassResetChange(e)}
                        error={state.formErrors.email}
                        type="email"
                        value={state.email}
                        name="email"
                        className={state.emailValid ? 'valid' : state.formErrors.email !== "" ? "invalid" : ""}
                        placeholder={i18n.t(`login.your_email`)}
                    />
                </InputWrapStyled>
            </RowStyled>
            <ButtonWrapStyled className="restore">
                <Button as="a" href="/" label={i18n.t(`login.restore_password`)} size="big" width="100%" type="submit" />
            </ButtonWrapStyled>
            <TextBlockStyled>
                <LinkStyle
                    onClick={(e) => toResetPassword(e)}
                    color={c.blue_active}>{i18n.t(`login.back_to_entrance`)}
                </LinkStyle>
            </TextBlockStyled>
            {/* Здесь сообщение об ошибке */}
            <ErrorBlockStyled>
                <ErrorStyled> {message}</ErrorStyled>
                {serverErrors.map((error) => (
                    <ErrorStyled> {error}</ErrorStyled>
                ))}
            </ErrorBlockStyled>
        </FormStyled>

    // вкладка Входа
    const contentForTabLogin =
        <FormStyled
            onSubmit={(e) => handleLogInSubmit(e)}
            action="#" method="post"
        >
            <RowStyled>
                <InputWrapStyled>
                    <TextField
                        handleFieldChange={(e) => handleFieldLoginChange(e)}
                        type="email"
                        name="email"
                        placeholder="Email"
                        error={state.formErrors.email}
                        className={state.emailValid ? 'valid' : state.formErrors.email !== "" ? "invalid" : ""}
                        primary
                        value={state.email}
                    />
                </InputWrapStyled>
            </RowStyled>
            <RowStyled>
                <InputWrapStyled>
                    <TextField
                        handleFieldChange={(e) => handleFieldLoginChange(e)}
                        error={state.formErrors.password}
                        className={state.password ? 'valid' : state.formErrors.password !== "" ? "invalid" : ""}
                        type={state.isShowPass ? "text" : "password"}
                        name="password"
                        placeholder={i18n.t(`login.password`)}
                        value={state.password}
                    />
                    <InputIconWrapStyled onClick={() => updateState((prev) => ({ isShowPass: !prev.isShowPass }))}>
                        <Svg type={state.isShowPass ? "visibility" : "visibility_off"} />
                    </InputIconWrapStyled>
                </InputWrapStyled>
            </RowStyled>
            <RememberBlockStyled className="RememberBlockStyled" onClick={() => updateState((prev) => ({ rememberMe: !prev.rememberMe }))}>
                <CheckboxNew
                    name="rememberMe"
                    checked={state.rememberMe}
                />
                <Medium>{i18n.t(`login.remember_me`)}</Medium>
            </RememberBlockStyled>
            <Button as="a" href="/" label={i18n.t(`login.login_button`)} size="big" type="submit" width="100%" />
            <TextBlockStyled
                onClick={(e) => toResetPassword(e)}
                className="toResetPassword"
            >
                <LinkStyle color={c.blue_active}>{i18n.t(`login.forgot_your_password`)}</LinkStyle>
            </TextBlockStyled>
            {/* Здесь сообщение об ошибке */}
            <ErrorBlockStyled>
                <ErrorStyled> {message}</ErrorStyled>
                {serverErrors.map((error) => (
                    <ErrorStyled> {error}</ErrorStyled>
                ))}
            </ErrorBlockStyled>
        </FormStyled>

    /* вкладка регистрации */
    const contentForTabReg =
        <FormStyled
            onSubmit={(e) => handleRegSubmit(e)}
            action="#" method="post"
            style={{ minHeight: '40vh' }}
        >
            <RowStyled>
                <TextField
                    handleFieldChange={(e) => handleFieldChange(e)}
                    type="text"
                    name="fullName"
                    placeholder={i18n.t(`login.full_name`)}
                    minLength="4"
                    maxLength="50"
                    error={state.formErrors.fullName}
                    className={state.fullnamelValid ? "valid" : state.formErrors.fullName !== "" ? "invalid" : ""}
                />
            </RowStyled>

            <RowStyled>
                <InputWrapStyled className="half">
                    <TextField
                        handleFieldChange={(e) => handleFieldChange(e)}
                        name="newEmail"
                        type="email"
                        placeholder="Email*"
                        error={state.formErrors.newEmail}
                        className={state.newEmailValid ? "valid" : state.formErrors.newEmail !== "" ? "invalid" : ""}
                    />
                </InputWrapStyled>
                <InputWrapStyled className="half">
                    <Select
                        primary
                        content={countryList}
                        className={state.formErrors.country !== "" ? "invalid" : ""}
                        error={state.formErrors.country}
                        name="country"
                        selectWidth="true"
                        _showSearchingResults={(x) => showSearchingResults(x)}
                    />
                </InputWrapStyled>
            </RowStyled>
            <RowStyled>
                <InputWrapStyled className="half">
                    <TextField
                        className={(state.company !== "") ? "valid" : state.formErrors.company !== "" ? "invalid" : ""}
                        error={state.formErrors.company}
                        handleFieldChange={(e) => handleFieldChange(e)}
                        type="text"
                        name="company"
                        maxLength="100"
                        placeholder={i18n.t(`login.сompany`)}
                    />
                </InputWrapStyled>
                <InputWrapStyled className="half">
                    <TextField
                        className={(state.position !== "") ? "valid" : state.formErrors.position !== "" ? "invalid" : ""}
                        error={state.formErrors.position}
                        handleFieldChange={(e) => handleFieldChange(e)}
                        type="text"
                        name="position"
                        maxLength="100"
                        placeholder={i18n.t(`login.position`)}
                    />
                </InputWrapStyled>
            </RowStyled>
            <RowStyled>
                <InputWrapStyled className="half">
                    <TextField
                        handleFieldChange={(e) => handleFieldChange(e)}
                        type={state.isShowNewPass ? "text" : "password"}
                        name="newPassword"
                        placeholder={i18n.t(`login.create_password`)}
                        error={state.formErrors.newPassword}
                        maxLength="30"
                        className={state.newPasswordValid ? "valid" : state.formErrors.newPassword !== "" ? "invalid" : ""}
                    />
                    <InputIconWrapStyled onClick={() => updateState((prev) => ({ isShowNewPass: !prev.isShowNewPass }))}>
                        <Svg type={state.isShowNewPass ? "visibility" : "visibility_off"} />
                    </InputIconWrapStyled>
                </InputWrapStyled>
                <InputWrapStyled className="half" >
                    <TextField
                        handleFieldChange={(e) => handleFieldChange(e)}
                        type={state.isShowConfirmPass ? "text" : "password"}
                        name="confirmPassword"
                        placeholder={i18n.t(`login.confirm_password`)}
                        maxLength="30"
                        error={state.formErrors.confirmPassword}
                        className={state.confirmPasswordValid ? "valid" : state.formErrors.confirmPassword !== "" ? "invalid" : ""}
                    />
                    <InputIconWrapStyled onClick={() => updateState((prev) => ({ isShowConfirmPass: !prev.isShowConfirmPass }))}>
                        <Svg type={state.isShowConfirmPass ? "visibility" : "visibility_off"} />
                    </InputIconWrapStyled>
                </InputWrapStyled>
            </RowStyled>
            {/* Территория интересующих прав* */}
            <RowStyled>
                <SelectMultiple
                    updateData={updateSelectData}
                    closeAllSelect={state.closeAllSelect}
                    _closeAllSelect={_closeAllSelect}
                    validateReg={validateReg}
                    primary
                    content={territoryRightsList}
                    name="territory"
                    selectWidth="true"
                    error={state.formErrors.territoryChosen}
                    className={state.territoryValid ? "valid" : state.formErrors.territoryChosen !== "" ? "invalid" : ""}
                />
            </RowStyled>
            {/* вид прав */}
            <RowStyled>
                <SelectMultiple
                    updateData={updateSelectData}
                    closeAllSelect={state.closeAllSelect}
                    _closeAllSelect={_closeAllSelect}
                    primary
                    content={typeRightsList}
                    name="right"
                    selectWidth="true"
                    error={state.formErrors.rightChosen}
                    className={state.rightValid ? "valid" : state.formErrors.rightChosen !== "" ? "invalid" : ""}
                />
            </RowStyled>
            <RowStyled>
                <SelectMultiple
                    handleFieldChange={(e) => handleFieldChange(e)}
                    updateData={updateSelectData}
                    viewType={viewType}
                    _closeAllSelect={_closeAllSelect}
                    closeAllSelect={state.closeAllSelect}
                    primary
                    content={genresList}
                    position="top"
                    name="genres"
                    selectWidth="true"
                    error={state.formErrors.genresChosen}
                    className={state.genresValid ? "valid" : state.formErrors.genresChosen !== "" ? "invalid" : ""}
                />
            </RowStyled>
            <ButtonWrapStyled>
                <Button label={i18n.t(`login.register`)} size="big" type="submit" />
            </ButtonWrapStyled>
            {/* Здесь сообщение об ошибке */}
            <ErrorBlockStyled>
                <ErrorStyled> {message}</ErrorStyled>
                {serverErrors.map((error) => (
                    <ErrorStyled> {error}</ErrorStyled>
                ))}
            </ErrorBlockStyled>
        </FormStyled>

    return (
        <>
            <PopupLoginStyled>
                <ListStyled>
                    {tabsItems.map((item, i) => (
                        <ItemStyled
                            key={i}
                            className={state.tabIndex === i ? "active" : ""}
                            onClick={() => handleToggleTabs(i)}
                        >
                            <H4 color={state.tabIndex === i ? "" : c.blue_active}>{item.title}</H4>
                        </ItemStyled>
                    ))}
                </ListStyled>

                <TabContainerStyled>
                    <ContentStyled className={state.tabIndex === 0 ? "opened" : "closed"}>
                        {!state.isShowRestorePass && !state.isShowSuccessRePas
                            ? contentForTabLogin // вкладка Входа
                            : state.isShowRestorePass
                                ? contentForTabRecoveryPass // вкладка восстановление пароля
                                :
                                // Успешная отправка сброса пароля на email
                                <FormStyled>
                                    <InfoFormStyled>{i18n.t(`login.password_reset_link`)}</InfoFormStyled>
                                </FormStyled>
                        }
                    </ContentStyled>
                    {/* вкладка Регистрации */}
                    <ContentStyled
                        onClick={() => dispatch(clearMessages())}
                        className={state.tabIndex === 1 ? "opened" : "closed"}>
                        {loadingRegisterInfo ?
                            // верстка вкладки регистрация
                            contentForTabReg
                            : 'Loading'}
                    </ContentStyled>
                </TabContainerStyled>
            </PopupLoginStyled>
        </>
    );
};

export default LogIn;
